/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 *
 * Carries the env's current settings.json (cookiewall_enabled, etc.) into
 * the server render so CookieContext / banner UI can decide whether to show
 * the cookiewall on first paint instead of fetching /api/settings after
 * hydration and popping in.
 */

import React, { createContext, useContext } from 'react';

export type SSRSettings = Record<string, unknown>;

const SSRSettingsContext = createContext<SSRSettings | null>(null);

export const SSRSettingsProvider: React.FC<{
  value: SSRSettings | null;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <SSRSettingsContext.Provider value={value}>{children}</SSRSettingsContext.Provider>
);

export function useSSRSettings(): SSRSettings | null {
  return useContext(SSRSettingsContext);
}
